import { useMemo } from 'react';
import { sanitizeHtml, RICH_TEXT_PROSE } from '../lib/richText';

/**
 * Render authored clause HTML safely. Sanitizes on every render (the canonical XSS guard) and
 * applies shared prose styling. Used by the admin terms view and the franchisee terms card so a
 * clause looks identical wherever it appears.
 */
export function RichText({ html, className = '' }: { html: string; className?: string }): JSX.Element {
  const clean = useMemo(() => sanitizeHtml(html), [html]);
  return <div className={`${RICH_TEXT_PROSE} ${className}`} dangerouslySetInnerHTML={{ __html: clean }} />;
}
